import React, { useEffect, useState } from 'react';
import Main from './Pages/Main';
import './Sass/base.scss';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Register, SignOut } from './Register/Register';

function App() {
  const [user] = useAuthState(auth);
  const [userName, setUserName] = useState('');
  const [profilePic, setProfilePic] = useState('');

  useEffect(() => {
    const getUserName = () => {
      auth.onAuthStateChanged((user) => {
        if (user && user.displayName) {
          setUserName(user.displayName);
          setProfilePic(user.photoURL || 'https://i.stack.imgur.com/34AD2.jpg');
        }
      });
    };
    getUserName();
  }, []);
  return (
    <>
      {user ? (
        <Main
          userName={userName}
          setUserName={setUserName}
          SignOut={SignOut}
          profilePic={profilePic}
          setProfilePic={setProfilePic}
        />
      ) : (
        <Register setUserName={setUserName} />
      )}
    </>
  );
}

export default App;
